export default {
  editPermissions: 'Nastaviť oprávnenia',
  safePassword: {
    summary: 'Skopírujte počiatočné heslo',
    details: 'Nasledujúce počiatočné heslo sa zobrazí iba raz. Poznačte si ho a odovzdajte novému používateľovi. Po prvom prihlásení bude používateľ vyzvaný na nastavenie trvalého hesla',
  },
  title: 'Vytvoriť nového používateľa',
};
